import { handleActions } from 'redux-actions';
import { State, usernameSignInError } from './action';

const initialState: State = {
  errors: {},
};

const reducer = handleActions(
  {
    [String(usernameSignInError)]: (state, { payload }) => {
      return { ...state, errors: payload.errors };
    },
  },
  initialState,
);

export default reducer;
